import React, { useState } from "react";
import { Row, Col, Card, CardBody, Input, Label, Button, Form, Alert } from "reactstrap";
import { post } from "../../helpers/api_helper";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import UploadImage from "common/uploadImage";
import { ADD_BANNER } from "helpers/api_endpoints";


//meta title
document.title = "Add Banner";

const AddBanner = () => {

    const [status, setStatus] = useState(0);
    const [name, setname] = useState('');
    const [text, setText] = useState('');
    const [shape, setShape] = useState('');
    const [description, setDescription] = useState('');
    const [image, setImage] = useState('');
    const [errorMsg, seterrorMsg] = useState('');
    const navigate = useNavigate();

    const handleSubmit = () => {
        const imagePath = document.getElementById('imagePath').value;
        post(ADD_BANNER, { name, status, shape, text, description, image: imagePath })
            .then(response => {
                if (response.code == 201) {
                    navigate('/banners', { state: { successMsg: 'Banner Added SuccessFully' } });
                }
            })
            .catch(error => {
                seterrorMsg('Banner Creation Failed');
            })
    }

    const handleToggleCheckBoxStatus = () => {
        if (status) {
            setStatus(0);
        }
        else {
            setStatus(1)
        }
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Banners" breadcrumbItem="Add Banner" />
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleSubmit();
                            return false;
                        }}
                    >
                        <Row>
                            <Col xl={12}>
                                <Card>
                                    <CardBody>
                                        <Row>
                                            {errorMsg ? <Alert color="danger">{errorMsg}</Alert> : null}
                                            <div className="form-group col-md-4 mt-2">
                                                <Label className="form-label"><Trans>Name</Trans></Label>
                                                <Input
                                                    name="name"
                                                    className="form-control"
                                                    placeholder="Enter  Name"
                                                    type="text"
                                                    onChange={(e) => setname(e.target.value)}
                                                    required ></Input>
                                            </div>
                                            <div className="form-group col-md-4 mt-2">
                                                <Label className="form-label"><Trans>Shape</Trans></Label>
                                                <Input
                                                    name="shape"
                                                    className="form-control"
                                                    placeholder="Enter Shape"
                                                    type="number"
                                                    onChange={(e) => setShape(e.target.value)}
                                                    required ></Input>
                                            </div>
                                            <div className="form-group col-md-4 mt-2">
                                                <Label className="form-label"><Trans>Text</Trans></Label>
                                                <Input
                                                    name="text"
                                                    className="form-control"
                                                    placeholder="Enter Text"
                                                    type="text"
                                                    onChange={(e) => setText(e.target.value)}
                                                    required ></Input>
                                            </div>
                                            <div className="form-group col-md-4 mt-2">
                                                <Label className="form-label"><Trans>Description</Trans></Label>
                                                <textarea name="description"
                                                    className="form-control"
                                                    placeholder="Enter Description"
                                                    onChange={(e) => setDescription(e.target.value)}></textarea>
                                            </div>

                                            <UploadImage state={{ InputLabel: 'Image', filePath: image, type: 'banners', isFullPath: true }}></UploadImage>

                                            <div className="form-group col-md-2 mt-2">
                                                <Label className="form-label"><Trans>Status</Trans></Label>
                                                <div className="form-check form-check-end">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        value={1}
                                                        id="defaultCheck2"
                                                        checked={status}
                                                        onClick={handleToggleCheckBoxStatus}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="defaultCheck2"
                                                    >
                                                        <Trans>Active</Trans>
                                                    </label>
                                                </div>
                                            </div>

                                        </Row>
                                        <div className="mt-4">
                                            <Button type="submit" color="danger">
                                                <Trans>Submit</Trans>
                                            </Button>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>
        </React.Fragment>
    )
}

export default AddBanner
